import React from 'react';
import PageContainer from '@deliveroo/consumer-component-library/components/PageContainer';
import HomeFeedResults from '../../containers/HomeFeedResults';
import HomeFeedFilters from '../../containers/HomeFeedFilters';

import styles from './styles.scss';

function HomeLayout() {
  return (
    <PageContainer maxWidth="xx-large">
      <div className={styles['results-filters-wrapper']}>
        <div className={styles.sidebar}>
          <HomeFeedFilters />
        </div>
        <div className={styles.content}>
          <HomeFeedResults />
        </div>
      </div>
    </PageContainer>
  );
}

export default HomeLayout;
